import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { titleCase } from "title-case";

import type { InputTableQuerySpec, Protein } from "@/graphql.ts";
import { updateLastOpenProteinFeatureTableSpec } from "@/redux/modules/protein.ts";
import { createTableSpecForProteinParent } from "@/redux/modules/table-data.ts";
import { type IAppState } from "@/redux/reducer.ts";
import { type ReduxDispatch } from "@/redux/redux-utils.ts";
import { FEATURE_DISPLAY_NAME } from "@/settings/settings.ts";

import GenomicFeatureSelector, { type IFeatureOption } from "./GenomicFeatureSelector.js";

interface IProteinFeatureSelectorProps {
  protein: Protein;
}

export const OrthologTypeSelector = (props: IProteinFeatureSelectorProps) => {
  const proteinState = useSelector((state: IAppState) => state.protein);

  const [optionList, setOptionList] = useState<IFeatureOption[]>(null);
  const dispatch = useDispatch<ReduxDispatch>();

  useEffect(() => {
    const options =
      props.protein?.orthologTypes?.map((ortholog) => {
        return {
          label: titleCase(FEATURE_DISPLAY_NAME[ortholog]),
          color: undefined,
          showColorBadge: false,
          tableQuerySpec: createTableSpecForProteinParent(ortholog, props.protein?.id, null),
        };
      }) ?? [];

    setOptionList(options);
  }, [props.protein]);

  return (
    <GenomicFeatureSelector
      options={optionList}
      setLastOpenFeatureTableSpec={(tableSpec: InputTableQuerySpec) =>
        dispatch(updateLastOpenProteinFeatureTableSpec(tableSpec))
      }
      lastOpenFeatureTableSpec={proteinState.lastOpenFeatureTableSpec}
    />
  );
};
